module.exports = __webpack_public_path__ + "assets/5ddeb95e60b3798498d25f189675d1cb.svg";